export default
{
  path: 'crop-breed-history',
  name: 'CropBreedHistory',
  meta: {
    title: '历史种养品种',
    show: false
  },
  props: route => ({ landId: Number(route.query.landId) }),
  component: () => import('@/views/productManage/CropBreedHistory')
}
